import { jsxs as l, jsx as C } from "react/jsx-runtime";
function o(r) {
  return /* @__PURE__ */ l("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...r, children: [
    /* @__PURE__ */ C(
      "path",
      {
        d: "M21 11H16C15.9526 11 15.912 11.0206 15.8664 11.027C15.5079 9.606 14.3944 8.4921 12.9731 8.1336C12.9794 8.0879 13 8.0474 13 8V3C13 2.4478 12.5527 2 12 2C11.4473 2 11 2.4478 11 3V8C11 8.0474 11.0206 8.088 11.027 8.1336C9.6057 8.4921 8.4921 9.606 8.1336 11.027C8.0879 11.0207 8.0474 11 8 11H3C2.4473 11 2 11.4478 2 12C2 12.5522 2.4473 13 3 13H8C8.0474 13 8.088 12.9794 8.1336 12.973C8.4921 14.394 9.6056 15.5079 11.027 15.8664C11.0207 15.9121 11 15.9526 11 16V21C11 21.5522 11.4473 22 12 22C12.5527 22 13 21.5522 13 21V16C13 15.9526 12.9794 15.912 12.9731 15.8664C14.3944 15.5079 15.5079 14.394 15.8664 12.973C15.9121 12.9793 15.9526 13 16 13H21C21.5527 13 22 12.5522 22 12C22 11.4478 21.5527 11 21 11ZM12 14C10.8975 14 10 13.103 10 12C10 10.897 10.8975 10 12 10C13.1025 10 14 10.897 14 12C14 13.103 13.1025 14 12 14Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M17.7152 9.5H19.3149C18.5393 7.244 16.7561 5.4648 14.5 4.6894V6.2839C15.9337 6.9146 17.0844 8.0663 17.7152 9.5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M9.5 6.2839V4.6894C7.244 5.4648 5.4607 7.244 4.6851 9.5H6.2848C6.9157 8.0663 8.0663 6.9146 9.5 6.2839Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M6.2848 14.5H4.6851C5.4607 16.756 7.2439 18.5352 9.5 19.3106V17.7161C8.0663 17.0854 6.9156 15.9337 6.2848 14.5Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M14.5 17.7161V19.3106C16.756 18.5352 18.5393 16.756 19.3149 14.5H17.7152C17.0843 15.9337 15.9337 17.0854 14.5 17.7161Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  o as default
};
